
import { Component, Prop, Vue } from 'vue-property-decorator';

// SVG
import SettingsSVG from '@/assets/settings.svg';

@Component({
    components: { SettingsSVG },
})
export default class VButtonSettings extends Vue {
    @Prop({ type: Number, default: 0 })
    public count!: number;

    @Prop({ type: Boolean, default: false })
    public active!: boolean;

    @Prop({ type: String, default: '' })
    public tooltip!: boolean;
}
